<template>
  <div class="step3">
    <Spin v-if="loading" fix size="large"></Spin>
    <Alert type="warning" v-for="(s, index) in $config.uploadTips" :key="index">{{ s }}</Alert>
    <div class="select-wrap require">
      <span class="label">选择与所查档案的关系：</span>
      <Select :disabled="readonly" v-model="archivesType" @on-change="handleChange">
        <Option v-for="o in options" :value="o.value" :key="o.value">{{ o.text }}</Option>
      </Select>
    </div>
    <UploadBlock v-for="t in typeList" :key="t.type" :item="t" :files.sync="t.fileList" :readonly="readonly" />
    <div class="operation operation-bottom">
      <Button type="primary" @click="$emit('on-prev')">上一步</Button>
      <Button v-if="!readonly" type="primary" @click="handleSubmit">提交</Button>
    </div>
    <Evaluate ref="Evaluate" />
  </div>
</template>

<script>
import { GetArchTypes } from '@api'
import { typeImageMap } from '@libs/archivesTypeMap'
import UploadBlock from '@components/upload-block'
import Evaluate from './evaluate'
export default {
  name: 'step3',
  components: { UploadBlock,Evaluate },
  props: {
    readonly: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      archivesType: '',
      options: [],
      typeList: [],
      loading: false
    }
  },
  async mounted() {
    await this.buildOptions()
    const type = this.data.ArchiveQueryType || ''
    this.archivesType = type
    this.handleChange(type)
    await this.$nextTick()
    this.setFiles()
  },
  methods: {
    openEvaluate(SubscribeNo) {
      this.$refs.Evaluate.open(SubscribeNo)
      return true;
    },
    async buildOptions() {
      this.loading = true
      try {
        const { data } = await GetArchTypes({})
        this.options = data.map(m => ({
          value: m.SystemInfoCode,
          text: m.SystemInfoName,
          typeList: typeImageMap[m.SystemInfoCode]
        }))
        this.options.unshift({ text: '请选择', value: '' })
      } catch (e) {
        console.error(e)
      }
      this.loading = false
    },
    handleChange(value) {
      // 非空处理
      if (!value) {
        this.typeList = []
        return
      }
      const item = this.options.find(f => f.value === value)
      console.log(item);
      this.typeList = item.typeList
    },
    setFiles() {
      const files = this.data.UploadFiles || []
      files.map(m => {
        const typeObj = this.typeList.find(f => f.type === m.FileType)
        typeObj.fileList = m.FileName.map(p => ({
          previewURL: `${this.$config.baseUrl}${m.FilePath}${p}`,
          response: p,
          status: 'finished'
        }))
      })
    },
    handleSubmit() {
      // 下拉选择器必填验证
      if (!this.archivesType) {
        this.$Message.warning('请选择与所查档案的关系')
        return
      }
      // 上传文件必填验证
      const verification = this.typeList.some(s => {
        if (s.require && !s.fileList.length) {
          this.$Message.warning(s.title)
          return true
        }
      })
      if (verification) return
      this.$emit('on-files', this.typeList, this.archivesType)
      this.$emit('on-submit',this.openEvaluate)
    }
  }
}
</script>

<style lang="less" scoped>
.step3 {
  position: relative;
}

.select-wrap {
  display: flex;
  align-items: center;
  margin-bottom: 16px;

  .label {
    padding: 10px 12px 10px 0;
  }

  .ivu-select {
    flex: 1;
  }
}
</style>